import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { api, extractApiError } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("common.success"));
    } catch (err) {
      toast.error(translateApiError(err, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgot.title")} subtitle={t("auth.forgot.subtitle")} testId="forgot-page">
      {sent ? (
        <div className="p-4 rounded-lg bg-secondary text-sm" data-testid="forgot-success">
          {t("common.success")}. Check your email / consultez vos e-mails.
        </div>
      ) : (
        <form className="space-y-4" onSubmit={onSubmit}>
          <div>
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 mt-1" data-testid="forgot-email-input" />
          </div>
          <Button type="submit" size="lg" className="w-full h-12" disabled={loading} data-testid="forgot-submit-button">
            {loading ? t("common.loading") : t("auth.forgot.submit")}
          </Button>
        </form>
      )}
      <div className="mt-8 text-center text-sm">
        <Link to="/login" className="text-primary hover:underline" data-testid="back-to-login">
          ← {t("auth.forgot.back")}
        </Link>
      </div>
    </AuthShell>
  );
}
